import { render, staticRenderFns } from "./EmailBubble.vue?vue&type=template&id=18684d1e&scoped=true&"
import script from "./EmailBubble.vue?vue&type=script&lang=js&"
export * from "./EmailBubble.vue?vue&type=script&lang=js&"
import style0 from "./EmailBubble.vue?vue&type=style&index=0&id=18684d1e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18684d1e",
  null
  
)

export default component.exports